const customColors = {
 black: '#000000',
 darkestGray: '#2B2B2B',
 darkGray: '#686868',
 gray: '#969696',
 lightGray: '#BDBDBD',
 lightestGray: '#DDDDDD',
 white: '#FFFFFF',
 blue: '#6080FF',
 darkBlue: '#4666E5',
 lightBlue: '#F3F5FD',
 green: '#01C0AE',
 lightGreen: '#DDFDE9',
 red: '#FE5F5F',
 lightRed: '#FFC6C6',
 lightestRed: '#FEEFEF',
 orange: '#F68D2B',
 lightOrange: '#F9E3CE',
 yellow: '#F4E19D',
 lightYellow: '#FCF7E6',
 bg1: '#E8EAF4',
 bg2: '#F3F4F8',
};

export default customColors;
